import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';
import { customStylesSm, DropdownIndicator } from '~/Styles/reactSelectStyles';

export default function Autorizacao(props) {
  var autorizacao = props.autorizacao || { justificativa: '', codigo_usuario: '', senha: '' };
  var setAutorizacao = props.setAutorizacao;
  var obrigatorio = !!props.obrigatorio;
  var somenteJustificativa = !!props.somenteJustificativa;
  var avisoAlcada = props.avisoAlcada || '';
  var isCondicaoEspecial = !!props.isCondicaoEspecial;
  var porcentagemDesconto = props.porcentagemDesconto || 0;
  var codigoFamilia = props.codigoFamilia || 0;
  var travarCondicao = !!props.travarCondicao;

  var [validando, setValidando] = useState(false);
  var [validado, setValidado] = useState(false);
  var [usuarios, setUsuarios] = useState([]);
  var [carregandoUsuarios, setCarregandoUsuarios] = useState(false);

  useEffect(function() {
    if (somenteJustificativa) {
      setUsuarios([]);
      setCarregandoUsuarios(false);
      return;
    }
    setCarregandoUsuarios(true);
    api.buscarUsuariosAutorizadoresVenda(
      isCondicaoEspecial,
      String(porcentagemDesconto || 0).replace('.', ','),
      codigoFamilia,
      travarCondicao
    )
      .then(function(res) {
        setUsuarios(Array.isArray(res) ? res : []);
      })
      .catch(function() { setUsuarios([]); })
      .finally(function() { setCarregandoUsuarios(false); });
  }, [somenteJustificativa, isCondicaoEspecial, porcentagemDesconto, codigoFamilia, travarCondicao]);

  var optionsUsuarios = usuarios.map(function(u) {
    return { value: u.codigo, label: u.nome };
  });

  var usuarioSelecionado = optionsUsuarios.find(function(o) {
    return o.value === autorizacao.codigo_usuario;
  }) || null;

  var handleUsuarioChange = useCallback(function(option) {
    setAutorizacao(Object.assign({}, autorizacao, {
      codigo_usuario: option ? option.value : '',
    }));
    setValidado(false);
  }, [autorizacao, setAutorizacao]);

  var handleSenhaChange = useCallback(function(e) {
    setAutorizacao(Object.assign({}, autorizacao, { senha: e.target.value }));
    setValidado(false);
  }, [autorizacao, setAutorizacao]);

  var handleJustificativaChange = useCallback(function(e) {
    setAutorizacao(Object.assign({}, autorizacao, { justificativa: e.target.value }));
  }, [autorizacao, setAutorizacao]);

  var handleValidar = useCallback(function() {
    if (!autorizacao.codigo_usuario || !autorizacao.senha) {
      toast.warn('Selecione o usuário e preencha a senha');
      return;
    }
    setValidando(true);
    api.validarUsuarioSenhaSimulador(autorizacao.codigo_usuario, autorizacao.senha)
      .then(function(res) {
        var ok = res === true || (res && res.valido === true);
        if (ok) {
          setValidado(true);
          toast.success('Credenciais válidas');
        } else {
          setValidado(false);
          toast.error('Credenciais inválidas');
        }
      })
      .catch(function(err) {
        setValidado(false);
        toast.error('Erro: ' + (err.message || 'falha na validação'));
      })
      .finally(function() { setValidando(false); });
  }, [autorizacao]);

  return (
    <Card className="mb-2 border-secondary">
      <Card.Body className="py-2">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="mb-0 text-secondary">
            <strong>Autorização</strong>
            {obrigatorio && <span className="text-danger ml-1">*</span>}
          </h6>
          {!somenteJustificativa && validado && (
            <small className="text-success font-weight-bold">✓ Credenciais validadas</small>
          )}
        </div>

        <Alert variant={obrigatorio ? 'warning' : 'info'} className="py-1 mb-2 small">
          {somenteJustificativa
            ? (avisoAlcada || 'Informe a justificativa para registrar a solicitação conforme a alçada aplicada.')
            : obrigatorio
            ? 'Esta venda possui condições especiais. Informe a justificativa; sem credenciais validadas, a venda será gravada aguardando aprovação conforme alçada.'
            : 'Opcional. Se informar um autorizador com credenciais válidas, a venda será efetivada imediatamente. Sem autorização, será gravada aguardando aprovação conforme as alçadas aplicáveis.'}
        </Alert>

        <Form.Group className="mb-2">
          <Form.Label className="small mb-1">
            Justificativa{obrigatorio && <span className="text-danger ml-1">*</span>}
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            size="sm"
            placeholder="Motivo da autorização..."
            value={autorizacao.justificativa}
            onChange={handleJustificativaChange}
          />
        </Form.Group>

        {!somenteJustificativa && (
          <Row className="align-items-end">
            <Col md={5} xs={12}>
              <Form.Group className="mb-2">
                <Form.Label className="small mb-1">Usuário autorizador</Form.Label>
                <Select
                  placeholder={carregandoUsuarios ? 'Carregando...' : 'Selecione...'}
                  options={optionsUsuarios}
                  value={usuarioSelecionado}
                  onChange={handleUsuarioChange}
                  styles={customStylesSm}
                  components={{ DropdownIndicator }}
                  isLoading={carregandoUsuarios}
                  isClearable
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </Form.Group>
            </Col>
            <Col md={4} xs={9}>
              <Form.Group className="mb-2">
                <Form.Label className="small mb-1">Senha</Form.Label>
                <Form.Control
                  size="sm"
                  type="password"
                  value={autorizacao.senha}
                  onChange={handleSenhaChange}
                />
              </Form.Group>
            </Col>
            <Col md={3} xs={3}>
              <Button
                size="sm"
                variant="outline-secondary"
                className="mb-2 w-100"
                onClick={handleValidar}
                disabled={validando || !autorizacao.codigo_usuario || !autorizacao.senha}
              >
                {validando ? <Spinner animation="border" size="sm" /> : 'Validar'}
              </Button>
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
}
